class Quiz
    constructor: (el) ->
        @.$el = el
        @.$actualSheetEl = @.$el.querySelector '.quiz__actual-sheet'
        @.$backButton = @.$el.querySelector '.quiz__back'
        @.$completeButton = @.$el.querySelector '.quiz__complete'
        @.$evaluationResultEl = @.$el.querySelector '.quiz__evaluation__result'
        @.$evaluationTextEl = @.$el.querySelector '.quiz__evaluation__text'
        @.$footnotesEl = @.$el.querySelector '.quiz__footnotes'
        @.$forwardButton = @.$el.querySelector '.quiz__forward'
        @.$maxSheetsEl = @.$el.querySelector '.quiz__max-sheets'
        @.$progressbarEl = @.$el.querySelector '.quiz__progress'
        @.$sheetElements = []
        @.$sheetsEl = @.$el.querySelector '.quiz__sheets'
        @.$startOverButton = @.$el.querySelector '.quiz__start-over'

        @.$el.classList.add 'quiz--bound'

        @.actualSheet = parseInt(@.$actualSheetEl.textContent, 10) ? 0
        @.completed = false
        @.data = {}
        @.evaluated = false
        @.fulfilledSheets = []
        @.maxPoints = 0
        @.method = @.$el.dataset?.method ? false
        @.maxSheets = parseInt(@.$maxSheetsEl.textContent, 10) ? 0
        @.pointsReached = 0
        @.quizId = @.$el.dataset?.quizId ? false
        @.save = @.$el.dataset?.save ? false
        @.source = @.$el.dataset?.source ? false
        @.type = undefined

        if @.source && @.method
            @.GetData()
        else
            @.RemoveQuiz()
        return
    
    CalculateResult: ->
        if @.completed
            self = @
            @.fulfilledSheets.forEach (fulfilledSheet) ->
                self.pointsReached += fulfilledSheet.points
                self.maxPoints += fulfilledSheet.maxPoints
                return
            if @.maxPoints > 0
                if @.$evaluationResultEl
                    @.$evaluationResultEl.querySelector '.quiz__evaluation__result__reached'
                        .textContent = @.pointsReached
                    @.$evaluationResultEl.querySelector '.quiz__evaluation__result__max-points'
                        .textContent = @.maxPoints
            else
                @.$el.classList.add 'quiz--ehr'
        return

    CreateFootnotes: (footnotes) ->
        if footnotes && footnotes != ""
            if !@.$footnotesEl
                @.$footnotesEl = document.createElement 'div'
                @.$footnotesEl.classList.add 'quiz__footnotes'
                @.$el.appendChild @.$footnotesEl
            @.$footnotesEl.innerHTML = footnotes
        return

    CreateQuiz: ->
        self = @
        sheets = @.data?.sheets ? []
        @.type = @.data?.type ? "survey"
        @.$maxSheetsEl.innerHTML = sheets.length
        @.maxSheets = sheets.length
        if @.actualSheet < 1 && sheets.length > 0
            @.actualSheet = 1
            @.$actualSheetEl.innerHTML = 1
        if sheets.length < 1
            @.actualSheet = 0
            @.$actualSheetEl.innerHTML = 0
            @.$maxSheetsEl.innerHTML = 0
        else
            if @.actualSheet == 0
                @.actualSheet = 1
            @.$maxSheetsEl.innerHTML = sheets.length
        if @.maxSheets < 2
            @.$backButton.remove()
            @.$backButton = null
            @.$forwardButton.remove()
            @.$forwardButton = null
            @.$startOverButton.remove()
            @.$startOverButton = null
        @.$progressbarEl.dispatchEvent new CustomEvent 'progressbar-set-max', {
            bubbles: false
            detail: { 
                max: sheets.length
            }
        }
        @.$progressbarEl.value = @.actualSheet
        if @.actualSheet > 0 && sheets.length > 0
            if @.$forwardButton
                @.$forwardButton.classList.remove 'quiz__interaction--hidden'
        if @.actualSheet == @.maxSheets || @.actualSheet > 1
            if @.$startOverButton
                @.$startOverButton.removeAttribute 'disabled'
        
        @.CreateSheets()
        @.InitEvents()
        @.ValidateFulfillment()
        return

    CreateSheet: (sheetData, sheetNo) ->
        self = @
        description = sheetData.description ? ""
        explanation = sheetData.explanation ? ""
        interactions = sheetData.interactions ? []
        text = sheetData.text ? ""
        required = sheetData.required ? false
        sheetEl = document.createElement 'div'
        sheetEl.classList.add 'quiz__sheet'
        sheetEl.dataset.required = required
        sheetEl.dataset.no = sheetNo
        sheetEl.innerHTML = "
            <div class='quiz__sheet__text'>#{ text }</div>
            #{ if description != "" then "<div class='quiz__sheet__description'></div>" else "" }
            <div class='quiz__sheet__interactions'></div>
            #{ if explanation != "" then "<div class='quiz__sheet__explanation'></div>" else "" }
        "
        if description != ""
            sheetEl.querySelector '.quiz__sheet__description'
                .appendChild window.CreateRichtext {
                    textContent: description
                }
        if explanation != ""
            sheetEl.querySelector '.quiz__sheet__explanation'
                .appendChild window.CreateRichtext {
                    textContent: explanation
                }
        interactionsEl = sheetEl.querySelector '.quiz__sheet__interactions'
        interactionNo = 0
        maxPoints = 0
        points = 0
        interactions.forEach (interaction) ->
            type = interaction.type ? false
            fulfilledSheet = self.fulfilledSheets[sheetNo - 1]
            if interaction.points && interaction.type != "checkbox" && interaction.type != "star-rating"
                if interaction.points > maxPoints
                    maxPoints = interaction.points
            if type
                if type == "button"
                    buttonElOptions = {
                        color: if self.type == "quiz" then null else (interaction.color ? 'purple')
                        text: interaction.text
                        title: interaction.title
                        value: interaction.value
                    }
                    if interaction.value
                        buttonElOptions.attrs = {
                            'data-value': interaction.value
                        }
                    buttonEl = window.CreateButton buttonElOptions
                    buttonEl.dataset.ino = interactionNo
                    if interaction.uid
                        buttonEl.dataset.auid = interaction.uid
                    buttonEl.classList.add 'quiz__sheet__interaction'
                    if interaction.required
                        buttonEl.dataset.required = "true"
                    interactionsEl.appendChild buttonEl
                    if self.type == "quiz"
                        if interaction.rightAnswer
                            self.fulfilledSheets[self.fulfilledSheets.length-1].rightAnswer = buttonEl
                    buttonEl.addEventListener 'click', (e) ->
                        e.preventDefault()
                        if !buttonEl.disabled
                            quizSheetEl = buttonEl.closest('.quiz__sheet')
                            sheetNo = parseInt quizSheetEl.dataset.no, 10
                            fulfilledSheet = self.fulfilledSheets[sheetNo - 1]
                            ino = @.dataset?.ino ? -1
                            if ino > -1
                                if fulfilledSheet.qid && buttonEl.dataset?.auid
                                    fulfilledSheet.answerUids = [buttonEl.dataset.auid]
                                if self.data.sheets[sheetNo - 1].interactions[ino].points
                                    fulfilledSheet.points = self.data.sheets[sheetNo - 1].interactions[ino].points
                            fulfilledSheet.answer = buttonEl.dataset?.value ? buttonEl.querySelector('.button__text').textContent
                            fulfilledSheet.fulfilled = true
                            @.closest '.quiz__sheet__interactions'
                                .querySelectorAll '.button'
                                    .forEach (interactionsButtonEl) ->
                                        interactionsButtonEl.classList.add 'quiz__sheet__interaction--fulfilled'
                                        return
                            if self.type == "survey"
                                quizSheetEl.querySelectorAll '.button'
                                    .forEach (quizSheetButtonEl) ->
                                        quizSheetButtonEl.classList.remove 'button--primary'
                                        quizSheetButtonEl.classList.remove 'button--outline'
                                        quizSheetButtonEl.disabled = false
                                        return
                                buttonEl.classList.add 'button--outline'
                                buttonEl.disabled = true
                            if self.type == "quiz"
                                quizSheetEl.querySelectorAll '.button'
                                    .forEach (quizSheetButtonEl) ->
                                        if quizSheetButtonEl == fulfilledSheet.rightAnswer
                                            quizSheetButtonEl.classList.add 'quiz__sheet--right-answer'
                                        else
                                            quizSheetButtonEl.classList.add 'quiz__sheet--wrong-answer'
                                        quizSheetButtonEl.disabled = true
                                        return
                                buttonEl.classList.add 'button--primary'
                            if self.$forwardButton
                                self.$forwardButton.removeAttribute 'disabled'
                            self.ValidateFulfillment()
                        return
                if type == "range"
                    quizRangeEl = document.createElement 'div'
                    quizRangeEl.classList.add 'quiz__sheet__interaction', 'quiz__sheet__range'
                    quizRangeEl.innerHTML = "
                        <div class='quiz__sheet__range__input'></div>
                        <div class='quiz__sheet__range__range'></div>
                    "
                    if interaction.required
                        quizRangeEl.dataset.required = "true"
                    max = interaction.max ? 100
                    min = interaction.min ? 1
                    step = interaction.step ? 1
                    value = interaction.value ? 50
                    value = if value > max then max else value
                    points = value
                    inputName = interaction.name ? window.appUtils.GenerateId 'quiz-interaction_'
                    fulfilledSheet.answers[inputName] = value
                    quizRangeEl.classList.add 'quiz__sheet__interaction--fulfilled'
                    inputEl = window.CreateInput {
                        bindLater: true
                        max: max
                        min: min
                        name: inputName
                        outline: true
                        step: step
                        type: 'number'
                        value: value
                    }
                    quizRangeEl.querySelector '.quiz__sheet__range__input'
                        .appendChild inputEl
                    rangeEl = window.CreateRange {
                        bindLater: true
                        labels: interaction.labels
                        max: max
                        min: min
                        name: inputName
                        showHint: interaction.showHint ? true
                        step: step
                        unit: interaction.unit
                        value: value
                    }
                    quizRangeEl.querySelector '.quiz__sheet__range__range'
                        .appendChild rangeEl
                    inputEl.querySelector('.input__field').addEventListener 'change', (e) ->
                        value = parseInt inputEl.querySelector('.input__field').value, 10
                        fulfilledSheet.answers[@.name] = value
                        if fulfilledSheet.qid
                            fulfilledSheet.points = value
                        rangeEl.dispatchEvent new CustomEvent 'range-set-value', {
                            bubbles: false
                            detail: {
                                triggerEvents: false
                                value: value
                            }
                        }
                        interactionEl = @.closest '.quiz__sheet__interaction'
                        if value != ""
                            interactionEl.classList.add 'quiz__sheet__interaction--fulfilled'
                        else
                            interactionEl.classList.remove 'quiz__sheet__interaction--fulfilled'
                        self.ValidateFulfillment()
                        return
                    rangeEl.querySelector 'input[type="range"]'
                        .addEventListener 'input', (e) ->
                            value = parseInt rangeEl.querySelector('input[type="range"]').value, 10
                            fulfilledSheet.answers[@.name] = value
                            if fulfilledSheet.qid
                                fulfilledSheet.points = value
                            inputEl.dispatchEvent new CustomEvent 'input-set-value', {
                                bubbles: false
                                detail: {
                                    triggerEvents: false
                                    value: value
                                }
                            }
                            self.ValidateFulfillment()
                            return
                    interactionsEl.appendChild quizRangeEl
                if type == "input"
                    quizInputEl = document.createElement 'div'
                    quizInputEl.classList.add 'quiz__sheet__interaction', 'quiz__sheet__input'
                    if interaction.required
                        quizInputEl.dataset.required = "true"
                    if interaction.labelAfter
                        quizInputEl.classList.add 'quiz__sheet__input--label-after'
                    quizInputEl.innerHTML = "
                        #{ if interaction.label then "<label class='quiz__sheet__input__label'>#{ interaction.label }</label>" else ""}
                        <div class='quiz__sheet__input__input'></div>
                    "
                    inputName = interaction.name ? window.appUtils.GenerateId 'quiz-interaction_'
                    fulfilledSheet.answers[inputName] = null
                    inputEl = window.CreateInput {
                        bindLater: true
                        max: interaction.max
                        min: interaction.min
                        name: inputName
                        outline: true
                        placeholder: interaction.placeholder
                        step: interaction.step
                        type: interaction.inputType ? 'text'
                        value: interaction.value
                    }
                    if interaction.value
                        quizInputEl.classList.add 'quiz__sheet__interaction--fulfilled'
                        fulfilledSheet.answers[inputName] = interaction.value
                    inputEl.querySelector 'input'
                        .addEventListener 'input', (e) ->
                            value = inputEl.querySelector('input').value
                            inputEl.dispatchEvent new CustomEvent 'input-set-value', {
                                bubbles: false
                                detail: {
                                    triggerEvents: false
                                    value: value
                                }
                            }
                            fulfilledSheet.answers[@.name] = value
                            if fulfilledSheet.qid
                                fulfilledSheet.entered = value
                            interactionEl = @.closest '.quiz__sheet__interaction'
                            if value != ""
                                interactionEl.classList.add 'quiz__sheet__interaction--fulfilled'
                            else
                                interactionEl.classList.remove 'quiz__sheet__interaction--fulfilled'
                            self.ValidateFulfillment()
                            return
                    quizInputEl.querySelector '.quiz__sheet__input__input'
                        .appendChild inputEl
                    interactionsEl.appendChild quizInputEl
                if type == "select"
                    quizSelectEl = document.createElement 'div'
                    quizSelectEl.classList.add 'quiz__sheet__interaction', 'quiz__sheet__select'
                    if interaction.required
                        quizSelectEl.dataset.required = "true"
                    quizSelectEl.innerHTML = "
                        #{ if interaction.label then "<label class='quiz__sheet__select__label'>#{ interaction.label }</label>" else "" }
                        <div class='quiz__sheet__select__input'></div>
                    "
                    selectOptions = interaction.selectOptions ? {}
                    inputName = interaction.name ? window.appUtils.GenerateId 'quiz-interaction_'
                    fulfilledSheet.answers[inputName] = null
                    selectOptions.name = inputName
                    selectEl = window.CreateSelect selectOptions
                    selectElOptionElements = selectEl.querySelectorAll 'option[data-count]'
                    if selectOptions.options
                        count = 0
                        selectOptions.options.forEach (selectOption) ->
                            if selectOption.uid
                                if selectElOptionElements[count]
                                    selectElOptionElements[count].dataset.uid = selectOption.uid
                            count++
                            return
                    quizSelectEl.querySelector '.quiz__sheet__select__input'
                        .appendChild selectEl
                    selectEl.querySelector 'select'
                        .addEventListener 'change', (e) ->
                            fulfilledSheet.answers[@.name] = @.value
                            if fulfilledSheet.qid
                                fulfilledSheet.points = parseInt @.value, 10
                            if @.options[@.selectedIndex].dataset?.uid
                                fulfilledSheet.answerUids = [@.options[@.selectedIndex].dataset?.uid]
                            @.closest '.quiz__sheet__interaction'
                                .classList.add 'quiz__sheet__interaction--fulfilled'
                            self.ValidateFulfillment()
                    interactionsEl.appendChild quizSelectEl
                if type == "textarea"
                    quizTextareaEl = document.createElement 'div'
                    quizTextareaEl.classList.add 'quiz__sheet__interaction', 'quiz__sheet__textarea'
                    if interaction.required
                        quizTextareaEl.dataset.required = "true"
                    quizTextareaEl.innerHTML = "
                        #{ if interaction.label then "<label class='quiz__sheet__textarea__label'>#{ interaction.label }</label>" else "" }
                        <div class='quiz__sheet__textarea__input'></div>
                    "
                    inputName = interaction.name ? window.appUtils.GenerateId 'quiz-interaction_'
                    textareaEl = window.CreateTextarea {
                        bindLater: true
                        name: inputName
                        outline: true
                        placeholder: interaction.placeholder
                        value: interaction.value
                    }
                    textareaEl.querySelector 'textarea'
                        .addEventListener 'input', (e) ->
                            value = textareaEl.querySelector('textarea').value
                            fulfilledSheet.answers[@.name] = value
                            if fulfilledSheet.qid
                                fulfilledSheet.entered = value
                            interactionEl = @.closest '.quiz__sheet__interaction'
                            if value != ""
                                interactionEl.classList.add 'quiz__sheet__interaction--fulfilled'
                            else
                                interactionEl.classList.remove 'quiz__sheet__interaction--fulfilled'
                            self.ValidateFulfillment()
                            return
                    quizTextareaEl.querySelector '.quiz__sheet__textarea__input'
                        .appendChild textareaEl
                    interactionsEl.appendChild quizTextareaEl
                if type == "checkbox"
                    if interaction.points
                        maxPoints += interaction.points
                    quizCheckboxEl = document.createElement 'div'
                    quizCheckboxEl.classList.add 'quiz__sheet__interaction', 'quiz__sheet__checkbox'
                    if interaction.required
                        quizCheckboxEl.dataset.required = "true"
                    quizCheckboxEl.innerHTML = "
                        #{ if interaction.label then "<label class='quiz__sheet__checkbox__label'>#{ interaction.label }</label>" else "" }
                        <div class='quiz__sheet__checkbox__input'></div>
                    "
                    inputName = interaction.name ? window.appUtils.GenerateId 'quiz-interaction_'
                    checkboxEl = window.CreateCheckbox {
                        label: interaction.text
                        name: inputName
                        outline: true
                        required: interaction.required
                        value: interaction.value
                    }
                    if interaction.uid
                        checkboxEl.dataset.uid = interaction.uid
                    if interaction.points
                        checkboxEl.dataset.points = interaction.points
                    checkboxEl.querySelector 'input'
                        .addEventListener 'change', (e) ->
                            value = checkboxEl.textContent
                            fulfilledSheet.answers[@.name] = value
                            interactionEl = @.closest '.quiz__sheet__interaction'
                            uid = @.closest('.checkbox').dataset?.uid ? false
                            points = @.closest('.checkbox').dataset?.points ? false
                            if @.checked
                                interactionEl.classList.add 'quiz__sheet__interaction--fulfilled'
                                if uid
                                    fulfilledSheet.answerUids.push(uid)
                                if points
                                    fulfilledSheet.points += parseInt points, 10
                            else
                                interactionEl.classList.remove 'quiz__sheet__interaction--fulfilled'
                                if uid
                                    fulfilledSheet.answerUids = fulfilledSheet.answerUids.filter( (existingUid) -> return existingUid != uid)
                                if points
                                    fulfilledSheet.points -= parseInt points, 10
                            self.ValidateFulfillment()
                            return
                    quizCheckboxEl.querySelector '.quiz__sheet__checkbox__input'
                        .appendChild checkboxEl
                    interactionsEl.appendChild quizCheckboxEl
                if type == "star-rating"
                    quizStarRatingEl = document.createElement 'div'
                    quizStarRatingEl.classList.add 'quiz__sheet__interaction', 'quiz__sheet__star-rating'
                    if interaction.required
                        quizStarRatingEl.dataset.required = "true"
                    quizStarRatingEl.innerHTML = "
                        #{ if interaction.label then "<label class='quiz__sheet__star-rating__label'>#{ interaction.label }</label>" else "" }
                        <div class='quiz__sheet__star-rating__input'></div>
                    "
                    inputName = interaction.name ? window.appUtils.GenerateId 'quiz-interaction_'
                    stars = interaction.stars ? 1
                    starRatingEl = window.CreateStarRating {
                        bindLater: true
                        stars: stars
                    }
                    maxPoints = stars
                    starRatingEl.addEventListener 'star-rating-change', (e) ->
                        value = parseInt(e.detail?.rating ? 1, 10)
                        fulfilledSheet.points = value
                        interactionEl = @.closest '.quiz__sheet__interaction'
                        if value > 0
                            interactionEl.classList.add 'quiz__sheet__interaction--fulfilled'
                        else
                            interactionEl.classList.remove 'quiz__sheet__interaction--fulfilled'
                        self.ValidateFulfillment()
                        return
                    quizStarRatingEl.querySelector '.quiz__sheet__star-rating__input'
                        .appendChild starRatingEl
                    interactionsEl.appendChild quizStarRatingEl
            interactionNo++
            return
        @.fulfilledSheets[sheetNo - 1].maxPoints = maxPoints
        @.fulfilledSheets[sheetNo - 1].points = points
        return sheetEl
    
    CreateSheets: ->
        self = @
        sheets = @.data?.sheets ? []
        sheetCount = 1
        @.$sheetElements = []
        sheets.forEach (sheetData) ->
            required = sheetData.required ? false
            fulfilledSheet = {
                answer: null
                answers: {}
                answerUids: []
                entered: null
                fulfilled: false
                maxPoints: 0
                name: sheetData.name ? undefined
                no: sheetCount
                points: 0
                qid: sheetData.questionId ? false
                qmode: sheetData.questionMode ? false
                required: required
            }
            self.fulfilledSheets.push fulfilledSheet

            sheetEl = self.CreateSheet sheetData, sheetCount
            if self.actualSheet == sheetCount
                sheetEl.classList.add 'quiz__sheet--active'
                if !required
                    if self.$forwardButton
                        self.$forwardButton.removeAttribute 'disabled'
            self.$sheetsEl.appendChild sheetEl
            self.$sheetElements.push sheetEl
            sheetCount++
            return
        window.dispatchEvent new CustomEvent 'bind-components', { bubbles: false }
        return

    Evaluate: ->
        if @.completed
            if @.data.evaluations && @.data.evaluations.length > 0
                self = @
                matchingEvaluationContent = ""
                @.data.evaluations.forEach (evaluation) ->
                    if evaluation.evaluate && self.maxPoints > 0
                        comparePointsReached = (self.pointsReached / self.maxPoints) * 100
                    else
                        comparePointsReached = self.pointsReached
                    if comparePointsReached >= evaluation.minimum && (comparePointsReached <= evaluation.maximum || evaluation.maximum < evaluation.minimum)
                        matchingEvaluationContent = evaluation.bodytext
                    return
                if matchingEvaluationContent != ""
                    @.SetEvaluation matchingEvaluationContent
        return
    
    GetData: ->
        if @.method == 'GET' || @.method == 'POST'
            self = @
            if @.method == 'POST' && @.quizId
                body = {
                    quizId: parseInt(@.quizId, 10)
                }
            try
                request = window.appUtils.XMLHttpRequest @.method, @.source
                    , ->
                        if request.responseText && request.responseText != ""
                            try
                                if self.quizId
                                    response = JSON.parse request.responseText
                                    if response.success
                                        self.data = response.returnObject.quiz
                                        if self.data.footnotes
                                            self.CreateFootnotes self.data.footnotes
                                    else
                                        self.RemoveQuiz()
                                        return
                                else
                                    self.data = JSON.parse request.responseText
                            catch error
                                self.RemoveQuiz()
                                console.log "Fehler beim Versuch die Quiz-Datenquelle zu verarbeiten"
                                return
                            self.CreateQuiz()
                        else
                            console.log "Die Anfrage der Quiz-Datenquelle lieferte ein leeres Ergebnis"
                    , ->
                        console.log "Bei der Anfrage an die Quiz-Datenquelle ist leider ein Fehler aufgetreten"
                        return
                    , if self.method == 'POST' && self.quizId then JSON.stringify(body) else {}
            catch error
                @.RemoveQuiz()
                console.log "Fehler beim Versuch die Quiz-Datenquelle zu ermitteln"
        else
            try
                if window[@.source]
                    @.data = window[@.source]
                    @.CreateQuiz()
                else
                    @.RemoveQuiz()
                    console.log "Die Quiz-Datenquelle konnte nicht ermittelt werden"
            catch error
                @.RemoveQuiz()
                console.log "Fehler beim Versuch die Quiz-Datenquelle zu verarbeiten."
        return

    InitEvents: ->
        self = @
        if @.$forwardButton
            @.$forwardButton.addEventListener 'click', (e) ->
                if !self.$forwardButton.classList.contains 'quiz__interaction--hidden'
                    self.SlideSheets 1
                return
        if @.$backButton
            @.$backButton.addEventListener 'click', (e) ->
                if !self.$backButton.classList.contains 'quiz__interaction--hidden'
                    self.SlideSheets -1
                return
        if @.$startOverButton
            @.$startOverButton.addEventListener 'click', (e) ->
                if !self.$startOverButton.disabled && !self.evaluated
                    self.StartOver()
                return
        if @.$completeButton
            @.$completeButton.addEventListener 'click', (e) ->
                if self.completed && !self.evaluated
                    self.$el.dispatchEvent new CustomEvent 'quiz-completed', {
                        bubbles: false
                        detail: {
                            fulfilledSheets: self.fulfilledSheets
                        }
                    }
                    self.CalculateResult()
                    if self.data.evaluations
                        self.Evaluate()
                    if self.quizId
                        if self.save && self.method
                            self.SaveData()
                        else
                            self.ShowEvaluation()
                return
        return
    
    RemoveQuiz: ->
        @.$el.remove()
        delete @
        return
    
    SaveData: ->
        if @.completed && @.save && @.method && @.quizId
            self = @
            if @.method == 'POST' && @.quizId
                body = {
                    fulfilledSheets: @.fulfilledSheets
                    quizId: parseInt(@.quizId, 10)
                }
            try
                request = window.appUtils.XMLHttpRequest @.method, @.save
                    , ->
                        if request.responseText && request.responseText != ""
                            try
                                response = JSON.parse request.responseText
                                if !response.success
                                    console.log response.message
                                self.ShowEvaluation()
                            catch error
                                console.log "Fehler beim Versuch die Datenquelle zum Speichern des Quizes zu verarbeiten"
                                return
                        else
                            console.log "Die Anfrage der Datenquelle zum Speichern des Quizes lieferte ein leeres Ergebnis"
                    , ->
                        console.log "Bei der Anfrage an die Datenquelle zum Speichern des Quizes ist leider ein Fehler aufgetreten"
                        return
                    , if self.method == 'POST' && self.quizId then JSON.stringify(body) else {}
            catch error
                console.log "Fehler beim Versuch die Datenquelle zum Speichern des Quizes zu ermitteln"
        return
    
    SetEvaluation: (evaluationContent) ->
        richtextEl = window.CreateRichtext {
            textContent: evaluationContent
        }
        @.$evaluationTextEl.innerHTML = ""
        @.$evaluationTextEl.appendChild richtextEl
        window.dispatchEvent new CustomEvent 'bind-components', { bubbles: false }
        return
    
    ShowEvaluation: ->
        if @.completed
            @.evaluated = true
            @.$el.classList.add 'quiz--evaluated'
        return

    SlideSheets: (steps, asAbsoluteSheetNo) ->
        self = @
        asAbsoluteSheetNo = asAbsoluteSheetNo ? false
        if !asAbsoluteSheetNo
            actualSheet = @.actualSheet
            actualSheet += steps
        else
            actualSheet = steps
        actualSheet = if actualSheet <= @.maxSheets then actualSheet else @.maxSheets
        actualSheet = if actualSheet > 0 then actualSheet else 1
        @.actualSheet = actualSheet
        @.$actualSheetEl.textContent = @.actualSheet
        @.$progressbarEl.dispatchEvent new CustomEvent 'progressbar-set-value', {
            bubbles: false
            detail: {
                progress: self.actualSheet
            }
        }
        @.$sheetElements.forEach (sheetElement) ->
            sheetElement.classList.remove 'quiz__sheet--active'
            sheetElement.style.transform = "translateX(#{ -100 * (self.actualSheet - 1)}%)"
            return
        @.$sheetElements[@.actualSheet - 1].classList.add 'quiz__sheet--active'
        actualSheetFulfilled = @.fulfilledSheets[@.actualSheet - 1]
        if actualSheetFulfilled
            if actualSheetFulfilled.required && !actualSheetFulfilled.fulfilled
                @.$forwardButton.disabled = true
            else
                @.$forwardButton.disabled = false
        else
            @.$forwardButton.disabled = true
        if @.actualSheet > 1
            if @.$backButton
                @.$backButton.classList.remove 'quiz__interaction--hidden'
        else
            if @.$backButton
                @.$backButton.classList.add 'quiz__interaction--hidden'
        if @.actualSheet == @.maxSheets
            if @.$forwardButton
                @.$forwardButton.classList.add 'quiz__interaction--hidden'
        else
            if @.$forwardButton
                @.$forwardButton.classList.remove 'quiz__interaction--hidden'
        if @.actualSheet == @.maxSheets || @.actualSheet > 1
            if @.$startOverButton
                @.$startOverButton.disabled = false
        @.ValidateFulfillment()
        return
    
    StartOver: ->
        @.fulfilledSheets = []
        @.$sheetsEl.innerHTML = ""
        if @.$backButton
            @.$backButton.classList.add 'quiz__interaction--hidden'
        if @.$forwardButton
            @.$forwardButton.setAttribute 'disabled', true
        if @.$startOverButton
            @.$startOverButton.disabled = true
        @.CreateSheets()
        @.SlideSheets 1, true
        return
    
    ValidateFulfillment: ->
        actualSheetEl = @.$sheetElements[@.actualSheet - 1]
        fulfilledSheet = @.fulfilledSheets[@.actualSheet - 1]
        allFulfilled = true
        if fulfilledSheet.required
            onlyCheckboxes = true
            oneCheckboxChecked = false
            actualSheetEl.querySelectorAll '.quiz__sheet__interaction'
                .forEach (interactionEl) ->
                    if interactionEl.dataset?.required == "true" || interactionEl.type == "button"
                        if !interactionEl.classList.contains 'quiz__sheet__interaction--fulfilled'
                            allFulfilled = false
                    if !interactionEl.classList.contains 'quiz__sheet__checkbox'
                        onlyCheckboxes = false
                    else
                        if interactionEl.classList.contains 'quiz__sheet__interaction--fulfilled'
                            oneCheckboxChecked = true
                    return
            if onlyCheckboxes
                if !oneCheckboxChecked
                    allFulfilled = false
        if allFulfilled
            if fulfilledSheet
                fulfilledSheet.fulfilled = true
            if @.$forwardButton
                @.$forwardButton.removeAttribute 'disabled'
        else
            if fulfilledSheet
                fulfilledSheet.fulfilled = false
            if @.$forwardButton
                @.$forwardButton.setAttribute 'disabled', ''
        if @.fulfilledSheets.indexOf(fulfilledSheet) == @.fulfilledSheets.length - 1
            if allFulfilled
                @.$el.classList.add 'quiz--complete'
                @.completed = true
            else
                @.$el.classList.remove 'quiz--complete'
                @.completed = false
        else
            @.$el.classList.remove 'quiz--complete'
            @.completed = false
        return

BindQuizes = ->
    document.querySelectorAll '.quiz:not(.quiz--bound)'
        .forEach (el) ->
            new Quiz el
            return
    return

window.addEventListener 'bind-components', BindQuizes

class QuizCreate
    constructor: (options) ->
        @.$el = null

        @.attrs = options?.attrs ? false
        @.backText = options?.backText ? 'Zurück'
        @.backTitle = options?.backTitle ? @.backText
        @.bindLater = options?.bindLater ? false
        @.completeText = options?.completeText ? 'Abschließen'
        @.completeTitle = options?.completeTitle ? 'Eingabe beenden und absenden'
        @.dataMethod = options?.dataMethod ? false
        @.dataSave = options?.dataSave ? false
        @.dataSource = options?.dataSource ? false
        @.evaluationDefaultText = options?.evaluationDefaultText ? ''
        @.evaluationHeadlineText = options?.evaluationHeadlineText ? 'Vielen Dank für Ihre Teilnahme'
        @.evaluationHideResult = options?.evaluationHideResult ? false
        @.evaluationPointsText = options?.evaluationPointsText ? 'möglichen Punkten'
        @.forwardText = options?.forwardText ? 'Weiter'
        @.forwardTitle = options?.forwardTitle ? @.forwardText
        @.footnotes = options?.footnotes ? false
        @.ofText = options?.ofText ? 'von'
        @.preText = options?.preText ? false
        @.quizId = options?.quizId ? false
        @.startOverText = options?.startOverText ? 'Ganz von vorne anfangen'
        @.tag = options?.tag ? 'div'
        @.maxSheets = options?.maxSheets ? 0
        @.actualSheet = if @.maxSheets > 0 then (options?.actualSheet ? 1) else 0

        @.CreateElement()
        if !@.bindLater
            new Quiz @.$el
        return @.$el

    CreateElement: ->
        if @.dataSource && @.dataMethod
            @.$el = document.createElement @.tag
            @.$el.classList.add 'quiz'
            if @.dataMethod
                @.$el.dataset.method = @.dataMethod
            if @.dataSave
                @.$el.dataset.save = @.dataSave
            if @.dataSource
                @.$el.dataset.source = @.dataSource
            if @.attrs
                @.$el = window.appUtils.Attributes @.attrs, @.$el
            if @.evaluationHideResult
                @.$el.classList.add 'quiz--ehr'
            if @.quizId
                @.$el.dataset.quizId = @.quizId
            @.$el.innerHTML = "
                <div class='quiz__card'>
                    <div class='quiz__top'>
                        <div class='quiz__count'>#{ if @.preText then "<span class='quiz__pre-text'>#{ @.preText }</span>" else "" }</span><span class='quiz__actual-sheet'>#{ @.actualSheet }</span><span class='quiz__of-text'>#{ @.ofText }</span><span class='quiz__max-sheets'>#{ @maxSheets }</span></div>
                    </div>
                    <div class='quiz__sheets'></div>
                    <div class='quiz__evaluation'>
                    </div>
                    <div class='quiz__bottom'>
                        <button type='button' class='quiz__start-over' disabled>#{ @.startOverText }</button>
                    </div>
                </div>
                <div class='quiz__interaction'>
                </div>
                #{ if @.footnotes then "<div class='quiz__footnotes'>#{ @.footnotes }</div>" else "" }
            "
            @.$el.querySelector '.quiz__evaluation'
                .appendChild window.CreateHeadline {
                    level: 4
                    size: 4
                    text: @.evaluationHeadlineText
                }
            @.$el.querySelector '.quiz__evaluation'
                .innerHTML += "
                    <div class='quiz__evaluation__result'>
                        <div class='quiz__evaluation__result__reached'></div>
                        <div class='quiz__evaluation__result__max-points'></div>
                        <div class='quiz__evaluation__result__text'>#{ @.evaluationPointsText }</div>
                    </div>
                    <div class='quiz__evaluation__text'>#{ @.evaluationDefaultText }</div>
                "
            @.$el.querySelector '.quiz__top'
                .appendChild window.CreateProgressbar {
                    attrs: {
                        class: ['quiz__progress']
                    }
                    color: 'turqois'
                    max: @.maxSheets
                    progress: @.actualSheet
                }
            @.$el.querySelector '.quiz__interaction'
                .appendChild window.CreateButton {
                    attrs: {
                        class: ['quiz__back',(if @.actualSheet < 2 then 'quiz__interaction--hidden' else '')]
                    }
                    text: @.backText
                    title: @.backTitle
                }
            @.$el.querySelector '.quiz__interaction'
                .appendChild window.CreateButton {
                    attrs: {
                        class: ['quiz__forward', (if @.maxSheets < 2 then 'quiz__interaction--hidden' else '')]
                    }
                    disabled: true
                    text: @.forwardText
                    title: @.forwardTitle
                }
            @.$el.querySelector '.quiz__interaction'
                .appendChild window.CreateButton {
                    attrs: {
                        class: ['quiz__complete']
                    }
                    text: @.completeText
                    title: @.completeTitle
                }
        return

window.CreateQuiz = (options) ->
    return new QuizCreate options